import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAffinitydesignerComponent } from './simple-icons-affinitydesigner.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAffinitydesignerComponent ],
    exports:      [ SimpleIconsAffinitydesignerComponent ],
    bootstrap:    []
})
export class SimpleIconsAffinitydesignerModule {}
